import { Dashboard } from "./Dashboard";
import { CheckMyself } from "./CheckMyself";
import { Reports } from "./Reports";
import { DashboardView } from "./DashboardView";
import { DashboardNew } from "./DashboardNew";
import { ReportsView } from "./ReportsView";
import { ReportsNew } from "./ReportsNew";

const teacher = {
  Dashboard,
  CheckMyself,
  Reports,
  DashboardView,
  DashboardNew,
  ReportsView,
  ReportsNew
}

export default teacher